import FlexBox from "lib/components/common/flex-box";
import SimpleButton from "lib/components/common/simple-button";
import SimpleCard from "lib/components/common/simple-card";
import SimpleDropdown from "lib/components/common/simple-dropdown";
import { getArrayOfValuesFromArray } from "lib/utils/array-utils";
import { getFullName } from "lib/utils/util";
import { FC } from "react";
import { Button } from "react-bootstrap";

interface ServiceFilterProps {
  isLoading?: boolean;
  clinics: Clinic[];
  practitioners: PractitionerDetails[];
  therapies: Therapy[];
  selectedClinicId?: string;
  selectedTherapyId?: string;
  selectedPractitionerId?: string;
  onClinicChange?: (id: string) => void;
  onTherapyChange?: (id: string) => void;
  onPractitionerChange?: (id: string) => void;
  onClearClicked?: () => void;
}

const ServiceFilter: FC<ServiceFilterProps> = ({
  isLoading,
  clinics,
  practitioners,
  therapies,
  selectedClinicId,
  selectedTherapyId,
  selectedPractitionerId,
  onClinicChange,
  onTherapyChange,
  onPractitionerChange,
  onClearClicked,
}) => {
  return (
    <SimpleCard
      title="Search"
      className="shadow-sm"
      isLoading={isLoading}
    >
      <FlexBox direction="column" gap={"2"}>
        <SimpleDropdown
          showAllTitle="All Clinics"
          options={getArrayOfValuesFromArray(clinics, "name")}
          values={getArrayOfValuesFromArray(clinics, "id")}
          selectedValue={selectedClinicId}
          onSelectValue={onClinicChange}
          label="Select Clinic"
        />
        <SimpleDropdown
          showAllTitle="All Therapies"
          options={getArrayOfValuesFromArray(therapies, "name")}
          values={getArrayOfValuesFromArray(therapies, "id")}
          selectedValue={selectedTherapyId}
          onSelectValue={onTherapyChange}
          label="Select Therapy"
        />
        <SimpleDropdown
          showAllTitle="All Practitioners"
          options={(practitioners ?? []).map((p) =>
            getFullName(p.firstName, p.lastName)
          )}
          values={getArrayOfValuesFromArray(practitioners, "id")}
          selectedValue={selectedPractitionerId}
          onSelectValue={onPractitionerChange}
          label="Select Practitioner"
        />

        <SimpleButton
          variant="primary"
          type="button"
          onClick={onClearClicked}
          className="mt-2"
        >
          Clear Filters
        </SimpleButton>
      </FlexBox>
    </SimpleCard>
  );
};

export default ServiceFilter;
